module.exports = __webpack_public_path__ + "img/mont-movil-recortada.011b9898.svg";